export const getLessonsPagination = (state) => {
  return state?.lessons?.lessonsPagination;
};

export const getIsShowStudentLesson = (state) => {
  return state?.lessons?.lessonCall.isShowStudentLesson;
};

export const getEditableStudentId = (state) => {
  return state?.lessons?.lessonCall.editableStudentId;
};

export const getCurrentBoardLessonIndex = (state) => {
  return state?.lessons?.currentBoardLessonIndex;
};

export const getIsCourseCategoryComplete = (state) => {
  return state?.lessons?.isCourseCategoryComplete;
};

export const getIsBasicModuleStructure = (state) => {
  return state?.lessons?.isBasicModuleStructure;
};

export const getIsLessonLoading = (state) => {
  return state?.lessons?.lessonCall.isLessonLoading;
};

export const getAllowedParticipants = (state) => {
  return state?.lessons?.lessonCall.allowedParticipants;
};

export const getCurrentBoardLesson = (state) => {
  return state?.lessons?.currentBoardLesson;
};

export const getCourseAlias = (state) => {
  return state?.lessons?.courseAlias;
};

export const getSelectedEventLesson = (state) => {
  return state?.lessons?.selectedEventLesson;
};

export const getLessonsListFilter = (state) => {
  return state?.lessons?.lessonsListFilter;
};

export const getStudentsListTab = (state) => {
  return state?.lessons?.studentsListTab;
};

export const getControlOwnerUserId = (s) => s.lessons?.lessonCall.controlOwnerUserId;

export const getControlPendingFromUserId = (s) => s.lessons?.lessonCall.controlPendingFromUserId;

export const getHasMyVideoStream = (state) => {
  return state?.lessons?.lessonCall.hasMyVideoStream;
};

export const getMyVideoTrackId = (state) => {
  return state?.lessons?.lessonCall.myVideoTrackId;
};

export const getIsEditableLessons = (state) => {
  return state?.lessons?.isEditableLessons;
};

export const getIsLessonsPaginationReset = (state) => {
  return state?.lessons?.isLessonsPaginationReset;
};

export const getIsPreviewShowed = (state) => {
  return state?.lessons?.lessonCall.isPreviewShowed;
};

export const getCloneLessonMode = (state) => {
  return state?.lessons?.cloneLessonMode;
};

export const getIsAddExercisesToLesson = (state) => {
  return state?.lessons?.lessonCall.isAddExercisesToLesson;
};

export const getShowHeader = (state) => {
  return state?.lessons?.lessonCall.showHeader;
};

export const getIsLessThan10MinutesLeft = (state) => {
  return state?.lessons?.lessonCall.isLessThan10MinutesLeft;
};

export const getIsTemplateLessons = (state) => {
  return state?.lessons?.isTemplateLessons;
};

export const getIsSuperTeacherMode = (state) => {
  return state?.lessons?.isSuperTeacherMode;
};

export const getIsShowLessonExercisesList = (state) => {
  return state?.lessons?.lessonCall.isShowLessonExercisesList;
};

export const getPeerIdToRemove = (state) => {
  return state?.lessons?.lessonCall.peerIdToRemove;
};

export const getSelectedExerciseIndex = (state) => {
  return state?.lessons?.lessonCall.selectedExerciseIndex;
};

export const getIsRefetchLesson = (state) => {
  return state?.lessons?.lessonCall.isRefetchLesson;
};

export const getIsShowAddLessonExercisesList = (state) => {
  return state?.lessons?.lessonCall.isShowAddLessonExercisesList;
};

export const getIsMounting = (state) => {
  return state?.lessons?.lessonCall.isMounting;
};

export const getStudentFileSelectionFromTeacher = (state) => {
  return state?.lessons?.lessonCall.studentFileSelectionFromTeacher;
};

export const getPoorConnection = (state) => {
  return state?.lessons?.lessonCall.poorConnection;
};

export const getReconnecting = (state) => {
  return state?.lessons?.lessonCall.reconnecting;
};

export const getIsZeroLessonNotComplete = (state) => {
  return state?.lessons?.lessonCall.isZeroLessonNotComplete;
};

export const getIsCloseCall = (state) => {
  return state?.lessons?.lessonCall.isCloseCall;
};

export const getIsConnectionEstablished = (state) => {
  return state?.lessons?.lessonCall.getIsConnectionEstablished;
};

export const getIsUpdate = (state) => {
  return state?.lessons?.lessonCall.isUpdate;
};

export const getToolsTab = (state) => {
  return state?.lessons?.lessonCall?.toolsTab;
};

export const getIsLessonEstablished = (state) => {
  return state?.lessons?.lessonCall.isLessonEstablished;
};

export const getLesson = (state) => {
  return state?.lessons?.lesson;
};

export const getZeroLesson = (state) => {
  return state?.lessons?.zeroLesson;
};

export const getFullScreen = (state) => {
  return state?.lessons?.fullScreen;
};

export const getIsDocReaderShowed = (state) => {
  return state?.lessons?.lessonCall.isDocReaderShowed;
};

export const getIsUpdateEditableHomeTaskForm = (state) => {
  return state?.lessons?.lessonCall.isUpdateEditableHomeTaskForm;
};

export const getIsUnsetSelectedUser = (state) => {
  return state?.lessons?.lessonCall.isUnsetSelectedUser;
};

export const getZeroLessonTemplateLesson = (state) => {
  return state?.lessons?.zeroLessonTemplateLesson;
};

export const getDraggedLesson = (state) => {
  return state?.lessons?.draggedLesson;
};

export const getCloneLesson = (state) => {
  return state?.lessons?.cloneLesson;
};

export const getLessonTemplateLessonsPagination = (state) => {
  return state?.lessons?.lessonTemplateLessonsPagination;
};

export const getLessonTemplateLessonsPaginationLoading = (state) => {
  return state?.lessons?.lessonTemplateLessonsPagination.isLoading;
};

export const getIsSaveLessonTemplatesMode = (state) => {
  return state?.lessons?.lessonCall.isSaveLessonTemplatesMode;
};

export const getEditableLesson = (state) => {
  return state?.lessons?.editableLesson;
};

export const getSelectedZeroLessonId = (state) => {
  return state?.lessons?.lessonCall.selectedZeroLessonId;
};

export const getIsShowStudentVideoStreams = (state) => {
  return state?.lessons?.lessonCall.isShowStudentVideoStreams;
};

export const getIsCameraUsedByAnotherApp = (state) => {
  return state?.lessons?.lessonCall.isCameraUsedByAnotherApp;
};

export const getPeerId = (state) => {
  return state?.lessons?.lessonCall.peerId;
};

export const getIsMyVideoLoaded = (state) => {
  return state?.lessons?.lessonCall.isMyVideoLoaded;
};

export const getInitialLessonId = (state) => {
  return state?.lessons?.lessonCall.initialLessonId;
};

export const getIsShowPromptCameraAccessBanner = (state) => {
  return state?.lessons?.lessonCall.isShowPromptCameraAccessBanner;
};

export const getMyVideoLoading = (state) => {
  return state?.lessons?.lessonCall.myVideoLoading;
};

export const getIsMobileDevice = (state) => {
  return state?.lessons?.lessonCall.isMobileDevice;
};

export const getIsLessonComplete = (state) => {
  return state?.lessons?.lessonCall.isLessonComplete;
};

export const getIsRefetchUsersData = (state) => {
  return state?.lessons?.lessonCall.isRefetchUsersData;
};

export const getIsRefetchUserGroupsData = (state) => {
  return state?.lessons?.lessonCall.isRefetchUserGroupsData;
};

export const getIsCalling = (state) => {
  return state?.lessons?.lessonCall.isCalling;
};

export const getDeviceId = (state) => {
  return state?.lessons?.lessonCall.deviceId;
};
export const getRoomId = (state) => {
  return state?.lessons?.lessonCall.roomId;
};

export const getIsShowNoCameraAccessAlertBanner = (state) => {
  return state?.lessons?.lessonCall.isShowNoCameraAccessAlertBanner;
};

export const getIsCallStarted = (state) => {
  return state?.lessons?.lessonCall.isCallStarted;
};

export const getIsDateTimeExpired = (state) => {
  return state?.lessons?.lessonCall.isDateTimeExpired;
};

export const getIsStartLessonButtonShowed = (state) => {
  return state?.lessons?.lessonCall.isStartLessonButtonShowed;
};

export const getShowVideoDevices = (state) => {
  return state?.lessons?.lessonCall.showVideoDevices;
};

export const getIsSetFullScreen = (state) => {
  return state?.lessons?.lessonCall.isSetFullScreen;
};

export const getIsScreenSharing = (state) => {
  return state?.lessons?.lessonCall.isScreenSharing;
};

export const getVideoDevices = (state) => {
  return state?.lessons?.lessonCall.videoDevices;
};

export const getOpenedToolsBeforeFullScreen = (state) => {
  return state?.lessons?.lessonCall.openedToolsBeforeFullScreen;
};

export const getIsSketchMode = (state) => {
  return state?.lessons?.lessonCall.isSketchMode;
};

export const getIsStudentFullScreenMode = (state) => {
  return state?.lessons?.lessonCall.isStudentFullScreenMode;
};

export const getIsVideoConnectionEstablished = (state) => {
  return state?.lessons?.lessonCall.isVideoConnectionEstablished;
};

export const getIsLessonStatusInfo = (state) => {
  return state?.lessons?.lessonCall.isLessonStatusInfo;
};

export const getIsCallToolsCollapsed = (state) => {
  return state?.lessons?.lessonCall.isCallToolsCollapsed;
};

export const getIsFullScreenMode = (state) => {
  return state?.lessons?.lessonCall.isFullScreenMode;
};

export const getIsLessonResults = (state) => {
  return state?.lessons?.lessonCall.isLessonResults;
};
export const getShowVideoTools = (state) => {
  return state?.lessons?.lessonCall.showVideoTools;
};

export const getIsLessonExercisesList = (state) => {
  return state?.lessons?.lessonCall.isLessonExercisesList;
};

export const getIsMyPeerShowed = (state) => {
  return state?.lessons?.lessonCall.isMyPeerShowed;
};

export const getAudioMuted = (state) => {
  return state?.lessons?.lessonCall.audioMuted;
};

export const getVideoMuted = (state) => {
  return state?.lessons?.lessonCall.videoMuted;
};

export const getIsRecording = (state) => {
  return state?.lessons?.lessonCall.isRecording;
};

export const getEditableHomeTaskLesson = (state) => {
  return state?.lessons?.lessonCall.editableHomeTaskLesson;
};

export const getShowExerciseForStudent = (state) => {
  return state?.lessons?.lessonCall.showExerciseForStudent;
};

export const getIsZeroLessonCategoryChosen = (state) => {
  return state?.lessons?.lessonCall.isZeroLessonCategoryChosen;
};

export const getFullScreenUserId = (state) => {
  return state?.lessons?.lessonCall.fullScreenUserId;
};

export const getIsAccessToCameraMicDenied = (state) => {
  return state?.lessons?.lessonCall.isAccessToCameraMicDenied;
};

export const getIsAllButtonsMode = (state) => {
  return state?.lessons?.lessonCall.isAllButtonsMode;
};

export const getIsShowVideoStreams = (state) => {
  return state?.lessons?.lessonCall.isShowVideoStreams;
};

export const getLessonUsersList = (state) => {
  return state?.lessons?.lessonCall.lessonUsersList;
};

export const getIsMessagesList = (state) => {
  return state?.lessons?.lessonCall.isMessagesList;
};

export const getIsUsersList = (state) => {
  return state?.lessons?.lessonCall.isUsersList;
};

export const getLessonTemplateLessonsPaginationReset = (state) => {
  return state?.lessons?.lessonTemplateLessonsPaginationReset;
};

export const getZeroLessonDateTime = (state) => {
  return state?.lessons?.lessonCall.zeroLessonDateTime;
};

export const getIsCall = (state) => {
  return state?.lessons?.lessonCall.isCall;
};

export const getStudentFileSelection = (state) => {
  return state?.lessons?.lessonCall?.studentFileSelection;
};

export const getIsCloseFullScreen = (state) => {
  return state?.lessons?.lessonCall?.isCloseFullScreen;
};

export const getIsUpdateStudentLesson = (state) => {
  return state?.lessons?.lessonCall?.isUpdateStudentLesson;
};

export const getSelectedExerciseWithFiles = (state) => {
  return state?.lessons?.lessonCall?.selectedExerciseWithFiles;
};

export const getSelectedZeroLessonCategoryId = (state) =>
  state?.lessons?.lessonCall?.selectedZeroLessonCategoryId;
